import { NavLink, NavLinkProps } from 'react-router';

interface DefaultLinkProps extends NavLinkProps {
  href?: string;
  children?: React.ReactNode;
}

const DefaultLink = ({ children, href, to, className, style, ...restProps }: DefaultLinkProps) => {
  if (href?.startsWith('http')) {
    return (
      <a href={href} className={className as string} {...restProps}>
        {children}
      </a>
    );
  }

  return (
    <NavLink to={href ?? to} className={className} {...restProps}>
      {children}
    </NavLink>
  );
};

export default DefaultLink;
